<div class="lang-picker">
  <button
    type="button"
    class="lang-picker__btn"
    [class.is-open]="isOpen"
    (click)="toggleDropdown($event)"
    [attr.aria-expanded]="isOpen">
    <svg class="lang-picker__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M2 12h20"></path>
      <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"></path>
    </svg>
    <span class="lang-picker__label">{{ getCurrentLanguageName() }}</span>
    <svg class="lang-picker__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <div class="lang-picker__menu" *ngIf="isOpen">
    <button
      *ngFor="let lang of languages"
      type="button"
      class="lang-picker__option"
      [class.is-active]="(current$ | async) === lang.code"
      (click)="onChange(lang.code)">
      {{ lang.name }}
    </button>
  </div>
</div>
